import http from '@/libs/axios'

function ObjectToQueryString(object) {
  let query = ''
  if (!object) {
    return query
  }
  Object.keys(object).forEach(key => {
    if (object[key]) {
      query += `&${key}=${object[key]}`
    }
  })

  if (query.length) {
    query = `?${query.slice(1)}`
  }

  return query
}

export function getCrmSteps() {
  return http({
    url: '/sales_bpm/steps/',
    method: 'GET',
  })
}
export function getKanbanCardsList(query) {
  return http({
    url: `/sales_bpm/sales_bpm/${ObjectToQueryString(query)}`,
    method: 'GET',
  })
}
export function getOneLid(id) {
  return http({
    url: `/sales_bpm/sales_bpm/${id}/`,
    method: 'GET',
  })
}
export function getAllProducts(query) {
  return http({
    url: '/sales_bpm/products/',
    method: 'GET',
    params: query,
  })
}
export function addNewLid(data) {
  return http({
    url: '/sales_bpm/sales_bpm/',
    method: 'POST',
    data,
  })
}
export function updateOneLid(data) {
  return http({
    url: `/sales_bpm/sales_bpm/${data.id}/`,
    method: 'PATCH',
    data: data.data,
  })
}
